var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      class: _vm.compact ? "mb-0" : "",
      attrs: {
        description: _vm.description,
        label: _vm.label + ":",
        "label-cols-lg": _vm.labelColsLg,
        "label-cols-sm": _vm.labelColsSm,
        "label-for": _vm.id,
        "label-class": "fs-14 grey-color fw-700 align-items-baseline",
        "label-align": _vm.labelRight ? "right" : "left",
      },
    },
    [
      _c(
        "p",
        { staticClass: "fs-14 grey-color my-auto col-form-label" },
        [
          _vm.routerLink
            ? [
                _c(
                  "router-link",
                  {
                    staticClass: "atmo-button-link",
                    attrs: { to: _vm.routerLink, tag: "a", target: "_blank" },
                  },
                  [_vm._v(_vm._s(_vm.value))]
                ),
              ]
            : _vm.href
            ? [
                _c(
                  "a",
                  {
                    staticClass: "atmo-button-link",
                    attrs: { href: _vm.href, target: "_blank" },
                  },
                  [_vm._v(_vm._s(_vm.value))]
                ),
              ]
            : [_vm._v(" " + _vm._s(_vm.value) + " ")],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }